<template>
  <div id="listWidget" class="mb-5">
    <!-- <h4 class="mb-3">커튼 설정</h4> -->
    <div class="row">
      <div class="col-xl-6">
        <div class="text-muted fs-12px mb-2"><b>커튼</b></div>
        <div class="list-group mb-3">
          <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingCurtainRegistClick">
            <div class="flex-fill">
              <div class="fw-600">커튼 등록</div>
              <div class="fs-12px text-muted">
                커튼을 등록할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
            </ListGroupItem>
            <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingBlindRegistClick">
            <div class="flex-fill">
              <div class="fw-600">블라인드 등록</div>
              <div class="fs-12px text-muted">
                블라인드를 등록할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingCurtainListClick">
            <div class="flex-fill">
              <div class="fw-600">커튼 관리</div>
              <div class="fs-12px text-muted">
                커튼을 삭제할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import {
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  computed,  
} from 'vue';
const { emitter, mobile, logger } =
  getCurrentInstance().appContext.config.globalProperties;
const router = useRouter();

const onSettingCurtainRegistClick = () => router.push('/settings/curtain/regist');
const onSettingCurtainListClick = () => router.push('/settings/curtain/list');
const onSettingBlindRegistClick = () => router.push('/settings/blind/regist');

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'커튼 설정',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});    
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true});  
})
</script>
